import { render, staticRenderFns } from "./UploadGallery.vue?vue&type=template&id=b78d9e86&scoped=true&"
import script from "./UploadGallery.vue?vue&type=script&lang=js&"
export * from "./UploadGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78d9e86",
  null
  
)

export default component.exports